"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Connects = void 0;
var _react = require("react");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _connectTranslations = require("../shared/api/connectTranslations");
var _user = require("../entities/user");
var _Types = require("../Types");
var _functions = require("../utils/functions");
var _connectDevices = require("../shared/api/connectDevices");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Connects wrap for connect saga and requests
 * @param {Record<string, string>} urls list of backend urls
 * @param {JSX.Element}  children Site content
 * @returns {JSX.Element}
 *
 * @private
 */

const Connects = exports.Connects = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    children,
    urls
  } = _ref;
  const dispatch = (0, _reactRedux.useDispatch)();
  (0, _connectTranslations.useConnectTranslations)();
  (0, _connectDevices.useConnectDevices)();
  (0, _react.useEffect)(() => {
    dispatch((0, _user.setUrlsAction)(urls));
  }, [urls, dispatch]);
  (0, _react.useEffect)(() => {
    (0, _functions.checkWebPSupport)().then(status => dispatch((0, _user.setWebpSupportAction)(status)));
  }, [dispatch]);
  return children;
});
Connects.propTypes = {
  urls: _Types.urlsTypes,
  children: _propTypes.default.element.isRequired
};
Connects.defaultProps = {
  urls: _Types.urlsTypesDefault
};